export default function () {
  const filtersContainer = document.querySelector('[data-type="filters"]');

  if (!filtersContainer) return;
  const filterBtn = document.querySelectorAll('[data-type="filter-btn"]');

  function openFilter(filter) {
    filter.classList.add('opened');
  }

  function closeFilter() {
    const open = filtersContainer.querySelector('.opened');
    if (open) {
      open.classList.remove('opened');
    }
  }

  Array.from(filterBtn).forEach((el) => {
    const filterField = el.closest('[data-type="filters-item"]');
    el.addEventListener('click', () => {
      if (!filterField.classList.contains('opened')) {
        closeFilter();
        openFilter(filterField);
      } else {
        closeFilter();
      }
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-type="filters-item"]') && filterField.classList.contains('opened')) {
        closeFilter(filterField);
      }
    });
  });

  // const searchField = $('[data-filter="search"] .input');
  // $(searchField).on('input', function () {
  // });
}



// WEBPACK FOOTER //
// ./scripts/blocks/filters.js